<template>
  <!--  <div>-->
  <!--    <div-->
  <!--      id="unity"-->
  <!--      class="unity-area">-->
  <div style="overflow-y: hidden;background-color: rgb(35,31,32);width:100vw;height:100vh;">
    
    <div v-if="showClose" style="width: 100vw;background-color: white;position: fixed;top:0;height: 2vh">
      <div style=" background-color: white; width: 3vw;height: 2vh;font-size: 20px;position: fixed;right:17px;display: flex;flex-direction: row;align-items: center;justify-content: space-around;flex-wrap: nowrap">
        <i class="el-icon-minus" @click="toElectron('min')" style="cursor: pointer"></i>
        <i class="el-icon-close"  @click="toElectron('close')" style="cursor: pointer"></i>
      </div>
    </div>

    <div v-show="loadingStatus||(doneProgress!==100)"
         class="loading">
      <div class="img"></div>
      <div class="text">
        <div style="text-align: center;line-height: 2vw;margin-bottom: 2vw">{{$route.query.subject}}冷知识</div>
        {{text}}
      </div>
      <div class="line">
        <el-progress :text-inside="true"
                     :stroke-width="30"
                     :percentage="doneProgress"
                     color="#FDB912"></el-progress>
      </div>
      <div class="loading-img">

      </div>
    </div>

    <iframe    :style="{visibility:!loadingStatus&&(doneProgress===100)?'':'hidden'}"
              ref="window"
              src="/lab/凸透镜成像/index.html"
              class="iframe-page"
              importance="high"
              style="overflow:hidden; width: 80vw;height:45vw;margin-left: 10vw; background-color: rgb(35,31,32);margin-top: 2vw"
              @load="loaded"
              frameborder="no"
              border="0"
              marginwidth="0"
              marginheight="0"
              scrolling="no"
              allowtransparency="yes">
      </iframe>
    
  </div>

</template>

<script>
import NavHeader from '@/components/NavHeader'
import Unity from 'vue-unity-webgl'
import { recordApp } from '@/api/app'
import { getToken } from '@/utils/auth'
import DevicePixelRatio from "@/plugins/devicePixelRatio";
export default {
  name: 'webGL',
  components: { NavHeader, Unity },
  layout: 'home',
  data () {
    return {
      showClose:false,
      loadingStatus: true,
      width: '',
      unityURL:[],
      platform:" ",
      height: '',
      file: '',
      text: '',
      doneProgress: 0,
      showImg: false,
      imgBase: 'data:image/jpeg;base64,',
      biologicalText: [
        '一天之中，人在早上最高。',
        '胃肠道黏膜表面时一层油，是保护我们胃肠道黏膜的，如果过度饮酒，酒精就会把这层油洗掉，然后决定我们健康与否的肠道菌群就会发生失调，遭到破坏。',
        '有氧运动可以通过同时增强眶额叶对杏仁核的认知控制，或降低杏仁核自身的活动水平，从而减少负性情绪。',
        '保健品不是药物，不能代替药物治疗疾病。',
        '种子进入外太空后会遭受银河宇宙射线（GCR）的高能核成分HZE离子攻击，种子的DNA会遭到破坏，这时，DNA序列在酶的作用下会脱胎换骨，但这种诱发突变是有随机性的。',
        '打嗝不止，可用手指按压翳风穴。',
        '使用抗过敏也是会引起过敏的。',
        '出生时，我们的眼睛多大，现在还是多大，但是鼻子和耳朵一直都在长。',
        '一个人的寿命以80年来算，可以算得一生大约有2000000000秒。',
        '牡蛎的一生中可以多次变换性别。',
        '辣是痛觉而不是味觉。',
        '忘忧草其实是黄花菜，属于萱草属。',
        '大脑50%以上是由脂肪组成的。',
        '每周吃一次鱼的人，其每年的认知衰退速减少10% 。',
        '降压药和柚子千万不能一起吃。',
        '槟榔:世界知名“癌症制造机。”',
        '喂狗狗吃巧克力有很大可能会致死。',
        '在生物学分类中，狐属于犬科，驴属于马科，杉树属于松科，牵牛花属于旋花科,孔雀属于雉科。',
        '你的眼部肌肉每天运动的次数高达10万次。',
        '香蕉与人类拥有60%的相同DNA。',
        '戴耳机会让耳朵内的细菌大量繁殖。',
        '人的眼睛可以分辨出一千万种不同的颜色。',
        '头发中的角蛋白质可以分解成20多种氨基酸，这些营养成分可以做成酱油。',
        '眼角膜是唯一没有任何血液的身体部位。',
        '人体唾液含有一种叫做opiorphin的天然止痛药，比吗啡有效6倍。',
        '兔子的眼睛长在两侧，所以它的视野能覆盖360度，这也是兔子在野外赖以生存的本事。',
        '蚂蚁才是地球上最早会种植农业的生物，数百万年前的蚂蚁就懂得在蚁穴中培植菌类当做食物。',
      ],
      physicalText: [
        '其实厚玻璃杯遇热更容易炸裂。',
        '人体内的含碳量足够制作出9000支铅笔。',
        '人类眼睛的聚焦速度是没有任何一台照相机可以比得上的，眼睛平均每一秒就可以聚焦50次。',
        '蜘蛛或者壁虎的脚上有很多细毛，细到可以插在两个分子之间，足够强的范德瓦尔斯力让他们哪怕在玻璃上也能健步如飞。',
        '岩石学的术语中，所有名称末尾为“石”的固体，都不是岩石。',
        '如果物体的质量加倍，它的引力也会加倍。',
        '虹吸管。利用压差的不同，可以仅利用一根管子，将处在高处的液体抽到低处的液体中。',
        '挂在墙上的石英钟经常在电池没电时停在表盘上的“9”位置，停止移动。这是因为秒针在“9”位置受到大扭矩的阻碍最大。',
        '当自来水管从邻近的水龙头排水时，偶尔会有阵阵噪音。这是由于水冲出水龙头时水管的共振造成的。',
        '空调车车窗玻璃设计成双层的是为了防止传热。',
        '拍摄电视图像时，关闭相机闪光灯和室内照明，图像更清晰。',
        '汽车的底盘质量都较大，这样可以降低汽车的重心，增加汽车行驶时的稳度。',
        '汽车的车身设计成流线型，是为了减小汽车行驶时受到的阻力。',
        '汽车快速行驶时，车的尾部会形成一个低气压区，这是我们常常能在运动的汽车尾部看到卷扬的尘土形成原因。',
        '用沸水烫玻璃瓶的金属瓶盖，因为金属的热膨胀系数比玻璃大，可以用这个方法拧开很多紧瓶盖。',
        '热空气比冷空气要“轻”一些，在火焰周围的空气是比较热的，热空气的上升和四周冷空气流动来补充的过程，维持了燃着的火焰总是熊熊向上。',
        '麻绳提豆腐，提不起来——在压力一定时，如果受力面积小，则压强就大。',
        '坐井观天所见甚少——由于光沿直线传播，由几何作图知识可知，青蛙的视野将很小。',
        '摘不着的是镜中月，捞不着的是水中花——平面镜成的像为虚像。',
        '水上的葫芦，沉不下去——葫芦的密度小于水的密度，故只能漂浮在水面上。',
        '鸡蛋碰石头，完蛋——蛋壳承受的压强远小于石头能承受的压强，鸡蛋碰石头，鸡蛋先破。',
        '厚玻璃杯遇热更容易炸掉。',
        '物体做直线运动时，位移的大小不一定等于路程。'
      ],
      chemistryText: [
        '墙内开花墙外香——由于分了在不停的做无规则的运动，墙内的花香就会扩散到墙外。',
        '纸里包不住火——纸达到燃点就会燃烧。',
        '水银落地，无孔不入——水银的密度大于组成地面各物质的密度，水银又具有流动性，故它总是沉在其它物质的下面。',
        '如果原子没有空隙，那么地球上所有的人类会挤压到一个苹果的大小。',
        '液态的肥皂泡猛烈地收缩爆掉时，它的内部温度约为2WC，这几乎是太阳表面温度的4倍。',
        '人体内的碳含量，足够制作出9000支铅笔。',
        '热水的灭火效果比冷水好：与冷水相比，热水能在短时间产生水蒸气，把火源覆盖，从而起到隔绝氧气的作用。',
        '把鸡蛋泡醋里5小时，你会得到一个透明鸡蛋。',
        '洁厕液＋84消毒液=毒气！',
        '柑橘类的水果放在床头有助眠的效果。',
        '水果的酸度主要取决于水果中有机酸的含量，跟维生素C的含量没有直接关系。',
        '感冒药和退烧药不能混用。',
        '尺子和橡皮都是高分子聚合物材料，具有相似的性质，容易相溶而粘连在一起。',
        '当核污水流入大海后，只需要2个月左右就可以覆盖西北太平洋，3年左右到达美国西部海岸，11年内跟随洋流再回日本，45年内扩散至整个太平洋。',
        '糖炒栗子为什么要加糖？糖炒栗子表面糖的作用是粘去表皮杂质，让栗子看上去油光闪亮，而不是用来增加栗仁的甜度。'
      ]
    }
  },

  methods: {
    toElectron(method){
      this.$axios.get('http://127.0.0.1:3999/'+method)
    },
    getBase64 (blob) {

      return new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.readAsDataURL(blob);

        reader.onload = () => resolve(reader.result);

        reader.onerror = error => reject(error);

      });

    },
    loaded () {
      let that = this
      let file
      let head = this.$refs['window'].contentWindow.document.getElementsByTagName('head')
      let scriptRun = document.createElement('script')
      scriptRun.type = 'text/javascript'
      //https://data.xiyilab.com/apps/模考/凸透镜成像/Build/凸透镜成像.json
      //this.$route.query['app_uri']+'/Build/'+this.$route.query.name+'.json'
      let json_url = this.$route.query['app_uri'] + '/Build/' + this.$route.query.name + '.json'
      // let data_url=this.$route.query['app_uri']+'/Build/'+this.$route.query.name
      // let data_json={
      //   companyName:"西安翼加翼教育科技有限公司",
      //   productName:"观察番茄果肉细胞",
      //   dataUrl: data_url+".data.unityweb",
      //   wasmCodeUrl: data_url+".wasm.code.unityweb",
      //   wasmFrameworkUrl: data_url+".wasm.framework.unityweb",
      //   TOTAL_MEMORY: 268435456,
      //   graphicsAPI: ["WebGL 2.0", "WebGL 1.0"],
      //   webglContextAttributes: {"preserveDrawingBuffer": false},
      //   splashScreenStyle: "Dark",
      //   backgroundColor: "#231F20",
      //   cacheControl: {"default": "must-revalidate"}
      // }
      // JSON.stringify(data_json)
      json_url = 'https://api.xiyilab.com/v1/unity/webgl-loader-config?app_id=' + this.$route.query.app_id + '&memory=' +268435456+"&timestamp=" + new Date().getTime();
      if (this.$route.query.app_uri.indexOf('.json') != -1) {
        json_url = this.$route.query.app_uri
      }
      scriptRun.innerHTML = 'gameInstance = UnityLoader.instantiate("gameContainer", "' + json_url + '")'
      if (this.$refs['window'].contentWindow.document.readyState == "complete") {
        this.$refs['window'].contentWindow.document.body.appendChild(scriptRun)
      }
      this.$refs['window'].contentWindow['ExperimentBegin'] = () => {
        recordApp({ app_platform_id: this.$route.query.app_platform_id }).then(res => {
          console.log(res)
        })
        console.log('begin-------------------------------------------------------------')
        that.doneProgress = 100
        that.loadingStatus = false
        let nowDate = new Date()
        let date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          day: nowDate.getDate(),//几号：1，2，3，4....
          weekDay: nowDate.getDay(),//周几:1,2,3,4...
          hour: nowDate.getHours(),
          minute: nowDate.getMinutes(),
          second: nowDate.getSeconds()
        }


        if (this.$route.query.mode == "4") {
          switch(this.$route.query.name){
            case '元素周期表':{
              let startMessage
              if (!getToken() || (localStorage.getItem('user_identity') == '普通用户')) {
                startMessage = {
                  auth: 0,//用户权限  0:打开显示部分元素，1:打开显示全部元素，2:直接打开指定序号的元素
                  showItemList: '8,26',//显示的元素序号列表，从1开始，用,分割，例如:'1,2,3,4,5'
                  openItem: 1,//需要直接打开的元素序号，从1开始
                }
              }
              else if((localStorage.getItem('isSeller')&&localStorage.getItem('isSeller')=='true')||(sessionStorage.getItem('isSeller')&&sessionStorage.getItem('isSeller')=='true')){
                startMessage = {
                  auth: 0,//用户权限  0:打开显示部分元素，1:打开显示全部元素，2:直接打开指定序号的元素
                  showItemList: '6,8,17,26,30',//显示的元素序号列表，从1开始，用,分割，例如:'1,2,3,4,5'
                  openItem: 1,//需要直接打开的元素序号，从1开始
                }
              }
              else{
                startMessage = {
                  auth: 1,//用户权限  0:打开显示部分元素，1:打开显示全部元素，2:直接打开指定序号的元素
                  showItemList: '',//显示的元素序号列表，从1开始，用,分割，例如:'1,2,3,4,5'
                  openItem: 1,//需要直接打开的元素序号，从1开始
                }
              }
              console.log(startMessage)
              setTimeout(() => {
                this.$refs['window'].contentWindow['gameInstance'].SendMessage("JsToUnity", "startMessage", JSON.stringify(startMessage));
              }, 1000);
              break
            }
            case '器材库':{
              let startMessage='https://data.xiyilab.com/assetsbundles/'
              console.log(startMessage,'--------------------------------------------------')
              setTimeout(() => {
                this.$refs['window'].contentWindow['gameInstance'].SendMessage("JsToUnity", "startMessage", startMessage);
              }, 1000);
              break
            }
            case '显微镜':{
              break
            }
            case '家庭电路':{
              break
            }
            default:{
              break
            }
          }
        }
        else {

          let startMessage = {
            date: date,//时间  {"year":2021,"month":7,"day":2,"hour":15,"minute":2,"second":53}
            platform: this.$route.query.platform,//平台：webgl,iOS,Windows,steam VR...
            mode: parseInt(this.$route.query.mode),//模式：  练习：0  讲课：1  考试：2  回放：3
            url: 'https://api.xiyilab.com/v1',//服务器接口
            subject: this.$route.query.subject,//学科： ‘物理’，‘化学’，‘生物’
            publisher: this.$route.query.publisher,//出版社：‘人教版’，’粤教版‘，'北师大版'...
            grade: this.$route.query.grade,//年级：’七年级‘，’八年级‘，’九年级‘
            chapter: this.$route.query.chapter,//章节：’第一章‘，’第二章‘...
            token: getToken(), //token
            app_info_img_url: 'https://data.xiyilab.com/',
            ///////提交成绩参数
            task_id: parseInt(this.$route.query.task_id) || 0,
            app_id: parseInt(this.$route.query.app_id),
            app_platform_id: parseInt(this.$route.query.app_platform_id),

          }
          console.log(startMessage)
          setTimeout(() => {
            this.$refs['window'].contentWindow['gameInstance'].SendMessage("JsToUnity", "startMessage", JSON.stringify(startMessage));


            if (this.$route.query.mode == 3) {
              console.log('传入录播')
              console.log(JSON.stringify(this.file))
              this.$refs['window'].contentWindow.gameInstance.SendMessage("JsToUnity", "sendReviewToUnity", JSON.stringify(this.file))
            }



          }, 1000);
        }


      }
      this.$refs['window'].contentWindow['getDate'] = () => {
        let nowDate = new Date()
        let date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          day: nowDate.getDate(),//几号：1，2，3，4....
          weekDay: nowDate.getDay(),//周几:1,2,3,4...
          hour: nowDate.getHours(),
          minute: nowDate.getMinutes(),
          second: nowDate.getSeconds()
        }
        setTimeout(() => {
          this.$refs['window'].contentWindow.gameInstance.SendMessage("JsToUnity", "sendDate", JSON.stringify(date))
        }, 1000);
      }


      //unity向前端页面发送录播文件（字符串）
      //函数名：sendReviewToweb
      //参数：
      ////data:录播文件字符串，类型：String
      this.$refs['window'].contentWindow['sendReviewToWeb'] = (data) => {
        console.log(data)
        var blob = new Blob([data], { type: 'text/plain' })
        let postdata = new FormData()
        postdata.append('task_id', parseInt(this.$route.query.task_id))
        postdata.append('app_platform_id', parseInt(this.$route.query.app_platform_id))
        postdata.append('replay_data', blob)
        this.$axios.post('https://api.xiyilab.com/v1/apps/user-replay-data', postdata, {
          headers: {
            'Authorization': 'Bearer ' + getToken()
          }
        }).then(res => {
          console.log(res)
        })

      }
      //前端页面发送录播文件到unity

      //this.$refs['window'].contentWindow.gameInstance.SendMessage("JsToUnity", "sendReviewToUnity", JSON.stringify(file))




      //unity通过前端访问后台
      //函数名：getData
      //参数：
      //url:数据接口，如'https://api.xiyilab.com/v1/apps/user-lab-report'
      //method:请求方法，如 'get','post','put'...
      //data:需要的提交的数据，数据格式不限，Number,String,Boolean,Object均可，数据空用data===''判断
      //isFile:data是否为文件，如果是为1,否则为0
      this.$refs['window'].contentWindow['getData'] = (url, method, isFile, data) => {
        console.log(url, method, isFile, data)

        let returnData = ''

        let config = {
          method: method,
          url: url.toString(),
          headers: {
            'Authorization': 'Bearer ' + getToken()
          }
        }

        if (isFile === 0) {
          if (data !== '') {
            config.data = JSON.parse(data)
          }
          this.$axios(config).then(res => {
            if (res.data.status === 'ok') {
              console.log(res.data)
              returnData = res.data
              //返回的数据格式
              let message = {
                url: url,//请求接口
                method: method,//请求方法
                data: JSON.stringify(returnData)//请求到的数据,数据为完整格式如，
                // 请求出错：{"status":"no","code":102,"message":"密码错误"}，
                // 请求正确：{"status":"ok","data":{"user":{"id":6 ......},"csrf":null}}
              }
              console.log(JSON.stringify(returnData))
              this.$refs['window'].contentWindow['gameInstance'].SendMessage("JsToUnity", "ResponseData", JSON.stringify(message));
              // this.$message.success('成功')
            }
            else {
              returnData = res.data
              //this.$message.error('失败')
            }
          }).catch(e => {
            console.log(e)
            returnData = e
          })

        }
        else {
          let img = 'data:image/jpeg;base64,' + data
          let arr = img.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          let blob = new Blob([u8arr], { type: mime })
          blob.lastModifiedDate = new Date();
          blob.name = this.$route.query.app_id.toString + '_' + this.$route.query.app_platform_id.toString + '_图片.jpg';
          let aLink = document.createElement('a');
          let evt = document.createEvent("HTMLEvents");
          evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
          aLink.download = this.$route.query.name + '实验报告截图.jpg';
          aLink.href = URL.createObjectURL(blob);
          aLink.click();
          console.log(blob)
          let postdata = new FormData()
          postdata.append('app_platform_id', this.$route.query.app_platform_id)
          postdata.append('report_img', blob)
          this.$axios[method](url.toString(), postdata, {
            headers: {
              'Authorization': 'Bearer ' + getToken()
            }
          }).then(res => {
            console.log(res)
          })

        }
      }
    },
    // clear(){
    //   console.log(123)
    //   let request = window.indexedDB.deleteDatabase('/idbfs');
    //   request.onsuccess=e=>{
    //     console.log(e)
    //   }
    //   request.onerror=e=>{
    //     console.log(e)
    //   }
    // }
    // downloadFile(url){
    //   var a = document.createElement("a")
    //   a.setAttribute("href",url)
    //   a.setAttribute("download",'test')
    //   a.setAttribute("target","_blank")
    //   let clickEvent = document.createEvent("MouseEvents");
    //   clickEvent.initEvent("click", true, true);
    //   a.dispatchEvent(clickEvent);
    // }
  },
  created () {
      try{
        this.$axios.get('https://api.xiyilab.com/v1/unity/webgl-loader-config?app_id=' + this.$route.query.app_id).then(res=>{
          this.unityURL=Object.values(res.data).filter(item=>item.length>15)
        })
        // try {
        //   window.indexedDB.deleteDatabase('UnityCache')
        // }
        // catch (e) {
        //   console.log(e)
        // }
        let that=this
        window.onbeforeunload = function (e) {
          // let message = '页面关闭';
          // e = e || window.event;
          //
          // if (e) {
          //   e.returnValue = message;
          // }
          //
          // return message;
          window.localStorage.setItem('deleteList',that.unityURL)
        };

        let agent=navigator.userAgent.toLowerCase()
        if(agent.indexOf('electron')!=-1){
          this.showClose=true
        }
      }
      catch {
        this.showClose=false
      }
      if (this.$route.query.mode == 4) {

      }
      new DevicePixelRatio().init();
      let data
      let date = new Date()
      console.log(date)
      console.log(this.$route.query.subject + 'Text')
      if (this.$route.query.subject === '生物') {
        data = 'biologicalText'
      }
      else if (this.$route.query.subject === '化学') {
        data = 'chemistryText'
      }
      else {
        data = 'physicalText'
      }
      let len = this[data].length - 1
      this.text = this[data][Math.ceil(Math.random() * len)]
      console.log(window.innerHeight)
      if (this.$route.query.mode == 3) {
        this.$axios.get('https://api.xiyilab.com/v1/apps/user-replay-data?user_id=' + this.$route.query.user_id + '&task_id=' + this.$route.query.task_id + '&app_platform_id=' + this.$route.query.app_platform_id, {
          headers: {
            'Authorization': 'Bearer ' + getToken()
          }
        }).then(res => {
          console.log(res)
          if (res.data.status === 'ok') {
            this.file = res.data.data['replay_data']
            console.log(this.file)
            this.$axios.get(this.file, {
              headers: {
                'Authorization': 'Bearer ' + getToken()
              }
            }).then(res => {
              console.log(res)
              this.file = res.data
            })
          }
          else {

          }
        })
      }
  },

  destroyed () {

    //unity webGL异常关闭
    // this.$refs.unity['message']("JsToUnity","unityEnd",'webGL_will_close')

  },

  watch: {
    loadingStatus: function () {
      if (this.loadingStatus === false) {
        setTimeout(() => {
          this.doneProgress = 100
        }, 1000)
      }
    }
  },
  mounted () {

    let that = this
    let flag = 0
    let timer = setInterval(() => {

      let num = Math.ceil(Math.random() * 10)
      if (that.doneProgress + num < 100) {
        that.doneProgress += num
      }
      // loading.close();
      if (this.loadingStatus === false) {
        clearInterval(timer)

      }
    }, 500)

  }
}
</script>

<style scoped>
html body {
  border: 1px red solid;
}
.loading {
  width: 100vw;
  height: 100vh;
  background-image: url("http://data.xiyilab.com/web/main/static/实验/bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.img {
  position: fixed;
  z-index: 10;
  width: 15vw;
  top: 27vw;
  left: 14vw;
  background-image: url("http://data.xiyilab.com/web/main/static/实验/xy.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.text {
  width: 40vw;

  height: 10vw;
  margin: 43vh auto 0;
  line-height: 2vw;
  text-align: center;
  color: white;
  font-size: 1.5vw;
  font-family: test;
  font-weight: 600;
}
.line {
  width: 65vw;
  height: 2vw;
  left: 17.5vw;
  position: fixed;
  top: 40vw;
}
.loading-img {
  position: fixed;
  bottom: 5vw;
  left: 45vw;
  width: 10vw;
  height: 1vw;
  background-image: url("http://data.xiyilab.com/web/main/static/实验/正在加载配置文件....png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.el-progress,
/deep/ .el-progress-bar__outer {
  background-color: transparent;
  background-image: url("http://data.xiyilab.com/web/main/static/实验/加载白色.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 1.2vw;
  border-top-left-radius: 1.2vw;
}
/deep/ .el-progress-bar__inner {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  background-image: url("http://data.xiyilab.com/web/main/static/实验/加载进度.png");
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
/deep/ .el-progress-bar__innerText {
}
.unity {
  width: 100%;
  height: calc(100% - 150px);
}
.iframe-page::-webkit-scrollbar {
  display: none;
}
</style>
